module.exports = __webpack_public_path__ + "static/img/silver 1.726402c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/silver 1.png
// module id = 2oiu
// module chunks = 35